import {inlineError} from '@s-ui/decorators'

import {CommentsRepository} from './CommentsRepository.js'

export class HttpCommentsRepository extends CommentsRepository {
  constructor({
    config,
    fetchOrFail,
    fromGetCommentsResponseToCommentEntityMapper,
    fromPostResponseToCommentIdEntityMapper,
    getCommentsError,
    postCommentError
  }) {
    super()

    this._config = config
    this._fetchOrFail = fetchOrFail
    this._fromGetCommentsResponseToCommentEntityMapper = fromGetCommentsResponseToCommentEntityMapper
    this._fromPostResponseToCommentIdEntityMapper = fromPostResponseToCommentIdEntityMapper
    this._getCommentsError = getCommentsError
    this._postCommentError = postCommentError
  }

  @inlineError
  async getNewsComments(requestVO) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const TENANT = this._config.get('TENANT')

    const {articleId, items, pageNumber} = requestVO.toJSON()

    const endpointUrl = `${this._config.get(
      'CONTENTFUL_API_URL'
    )}/comments/${TENANT}/${articleId}?items=${items}&pageNumber=${pageNumber}`

    const [responseError, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._getCommentsError(message)
        }
      })
      .get(endpointUrl)

    if (responseError) return Promise.reject(responseError)

    return this._fromGetCommentsResponseToCommentEntityMapper.map(response.data)
  }

  @inlineError
  async postComment(requestVO) {
    const {articleId, userId, comment, commentId, token} = requestVO.toJSON()
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const {USERID, TOKEN} = this._config.get('REQUEST_HEADERS')
    const TENANT = this._config.get('TENANT')
    const extendedHeaders = userId && token ? {[USERID]: userId, [TOKEN]: token} : {}

    const endpointUrl = `${this._config.get('CONTENTFUL_API_URL')}/comments/${TENANT}/${articleId}`

    const [responseError, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._postCommentError(message)
        }
      })
      .post(
        endpointUrl,
        {
          comment,
          commentId
        },
        {
          headers: extendedHeaders
        }
      )

    if (responseError) return Promise.reject(responseError)

    return this._fromPostResponseToCommentIdEntityMapper.map(response.data)
  }
}
